import { ComponentProps } from 'react'

import { trackEvent } from '../../../../../lib/analytics'
import { useIsGiftCard } from '../hooks/useIsGiftCard'
import { UsePdpServerSidePropsData } from '../PdpServerSidePropsProvider'

import { GiftCardDetails } from './GiftCardDetails'
import { StandardProductDetails } from './StandardProductDetails'
import { Content, Layout } from './styles'

export type DetailsSectionProps = {
  product: UsePdpServerSidePropsData['product']
  deprecatedProps: ComponentProps<typeof StandardProductDetails>['deprecatedProps']
}

export const DetailsSection = ({ product, deprecatedProps }: DetailsSectionProps) => {
  const isGiftCard = useIsGiftCard({
    productGroupHandle: product.handle,
  })

  return (
    <Layout {...trackEvent({ category: 'product details', action: 'click product details' })}>
      <Content>
        {isGiftCard ? (
          <GiftCardDetails
            product={product}
            variantGroup={product.variantGroup}
            variant={product.variantGroup.variant}
          />
        ) : (
          <StandardProductDetails
            product={product}
            variantGroup={product.variantGroup}
            deprecatedProps={deprecatedProps}
          />
        )}
      </Content>
    </Layout>
  )
}
